import React, { useState, useEffect } from "react";
import axios from "axios";

export default function Main() {

  const [pass, setPassword] = useState('');
  const [username, setUsername] = useState('');

  useEffect(() => {
    const access = JSON.parse(localStorage.getItem("admin"));
    if (access) {
      window.location.replace("/main");
    }
  }, []);

  const login = async () => {

    try {

      const res = await axios.post('/api/user/login.php', {
        email: username,
        pass: pass
      });

      const data = res.data;

      console.log("API RESPONSE:", data);

      if (!data) {
        alert("No response from server");
        return;
      }

      if (data.success === false) {

        switch (data.msg) {

          case "missing_credentials":
            alert("Enter email and password");
            break;

          case "invalid_user":
            alert("User not found");
            break;

          case "wrong_password":
            alert("Wrong password");
            break;

          case "disabled":
            alert("Account disabled");
            break;

          default:
            alert("Login failed");
        }

        return;
      }

      // SUCCESS
      localStorage.setItem("admin", JSON.stringify(data.user));
      window.location.replace("/main");

    } catch (err) {
      console.log("LOGIN ERROR:", err);
      alert("Server error");
    }
  };

  return (
    <section className="login-register pt-6 pb-6">
      <div className="container">

        <div className="col-lg-4 mx-auto card" style={{ padding: "40px" }}>

          <h3 className="text-center">Login</h3>

          <input
            className="form-control mb-2"
            placeholder="Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <input
            className="form-control mb-2"
            type="password"
            placeholder="Password"
            value={pass}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            className="btn btn-primary w-100"
            onClick={login}
          >
            Submit
          </button>

        </div>

      </div>
    </section>
  );
}